import React, { Fragment, useState, useEffect } from "react";
import { SubNav, Row, useAPI, Grid } from "components/lib";
import { useParams } from "react-router-dom";
import { buildVerificationNavBarItems } from "./nav-bar-items";
import { SanctionsResults } from "./sanctions-results";
import { isScreeningRow, formatScreenedHeader } from "./screening-row";

export function SanctionsView(props) {
  const params = useParams();
  const verification = useAPI(`/api/verification/${params.id}`);
  const tranche2Permission = useAPI("/api/integration/tranche2/settings/can-complete");
  const canCompleteRiskAssessment = tranche2Permission?.data?.can_complete === true;
  const [navBarItems, setNavBarItems] = useState([]);
  // `verification` is the useAPI wrapper; the row itself sits inside it.
  const row = verification?.data?.verification?.[0];

  useEffect(() => {
    if (!verification.loading && verification.data) {
      setNavBarItems(
        buildVerificationNavBarItems(
          verification.data.verification[0],
          params,
          { canCompleteRiskAssessment }
        )
      );
    }
  }, [verification, canCompleteRiskAssessment]);

  return (
    <Fragment>
      <Grid>
        <Row>
          <SubNav items={navBarItems} />
          {/* Manual screening rows only: names the subject and the DOB the
              search was narrowed by. Every other row renders as before. */}
          {row && isScreeningRow(row.type) && (
            <p className="mb-4 font-semibold text-slate-900">
              {formatScreenedHeader(row, { withDob: true })}
            </p>
          )}
          {verification?.data?.verification?.[0]?.sanctions_results && (
            <SanctionsResults
              sanctionsResults={
                verification?.data?.verification?.[0]?.sanctions_results
              }
            />
          )}
        </Row>
      </Grid>
    </Fragment>
  );
}
